<app-default-layout
  [title]="'AUTHENTICATION.KENNWORT_ZURUECKSETZEN.TITLE' "
  [subtitle]="'AUTHENTICATION.KENNWORT_ZURUECKSETZEN.SUBTITLE' "
>

  <div class="row">
    <div class="col-md-8 offset-md-2">
      <form [formGroup]="pwZuruecksetzenForm" (ngSubmit)="this.save()" class="form-horizontal"
            accept-charset="UTF-8">


        <div class="form-group group-for-kennwort col mb-4">
          <div class="d-flex flex-row" style="margin-bottom: -15px">
            <div class="flex-grow-1 mr-2">
              <app-custom-input id="kennwort" type="text"
                                [type] = "pwHide? 'password':'text'"
                                class="flex-grow-1"
                                label="{{'REGISTRIERUNG.PW' |translate }}"
                                [customFormGroup]="pwZuruecksetzenForm"
                                data-cy="kennwort-alt"
              ></app-custom-input>
            </div>
            <fa-icon  style="margin-left: -25px; padding-top: 17px; margin-top: 15px; width: 26px; z-index:1"
                      [icon]="pwHide? faEye:faEyeSlash" (click) = "pwHide=!pwHide"
                      [title]="pwHide? translate.instant('LOGIN.PW-SHOW'):translate.instant('LOGIN.PW-HIDE')"
                      data-cy="btn-pwhide"
            >
            </fa-icon>
          </div>
          @if (pwZuruecksetzenForm?.controls?.kennwort?.invalid) {
            <div class="formcontrol-error-infotext" data-cy="kennwort-alt-error">
              {{ 'AUTHENTICATION.FORM_ERRORS.PASSWORD_TEMP_RESET' | translate }}
            </div>
          }
        </div>

        <div class="form-group group-for-neuKennwort col mb-4">
          <div class="d-flex flex-row" style="margin-bottom: -15px">
            <div class="flex-grow-1 mr-2">
              <app-custom-input id="kennwortNeu"
                                type="text"
                                [type] = "pwHide? 'password':'text'"
                                class="flex-grow-1"
                                label="{{'REGISTRIERUNG.NEW-PW' |translate }}"
                                [customFormGroup]="pwZuruecksetzenForm"
                                data-cy="kennwort"
              ></app-custom-input>
              @if (pwZuruecksetzenForm?.get('kennwortNeu')?.errors) {
                <div class="formcontrol-error-infotext" data-cy="kennwort-error">
                  {{ pwZuruecksetzenForm?.get('kennwortNeu')['infotextKey'] | translate }}
                  {{ pwZuruecksetzenForm?.get('kennwortNeu')['lengthKey'] | translate }}
                  {{ pwZuruecksetzenForm?.get('kennwortNeu')['numKey'] | translate }}
                  {{ pwZuruecksetzenForm?.get('kennwortNeu')['upperKey'] | translate }}
                  {{ pwZuruecksetzenForm?.get('kennwortNeu')['lowerKey'] | translate }}
                  {{ pwZuruecksetzenForm?.get('kennwortNeu')['specialKey'] | translate }}
                </div>
              }
            </div>
            <fa-icon  style="margin-left: -25px; padding-top: 17px; margin-top: 15px; width: 26px; z-index:1"
                      [icon]="pwHide? faEye:faEyeSlash" (click) = "pwHide=!pwHide"
                      [title]="pwHide? translate.instant('LOGIN.PW-SHOW'):translate.instant('LOGIN.PW-HIDE')"
                      data-cy="btn-pwhide-repeat"
            >
            </fa-icon>
          </div>
        </div>

        <div class="form-group group-for-kennwortbestaetigung col mb-4">
          <div class="d-flex flex-row" style="margin-bottom: -15px">
            <div class="flex-grow-1 mr-2">
              <app-custom-input id="kennwortbestaetigung" type="text"
                                [type] = "pwHide? 'password':'text'"
                                class="flex-grow-1"
                                label="{{'REGISTRIERUNG.PW-CONFIRMATION' |translate }}"
                                [customFormGroup]="pwZuruecksetzenForm"
                                data-cy="kennwortbestaetigung"
              ></app-custom-input>
              @if (pwZuruecksetzenForm?.controls?.kennwortbestaetigung?.errors?.passwordMismatch) {
                <div class="formcontrol-error-infotext" data-cy="kennwortbestaetigung-error">
                  {{ 'AUTHENTICATION.FORM_ERRORS.PASSWORD_MISMATCH' | translate }}
                </div>
              }
            </div>
            <fa-icon  style="margin-left: -25px; padding-top: 17px; margin-top: 15px; width: 26px; z-index:1"
                      [icon]="pwHide? faEye:faEyeSlash" (click) = "pwHide=!pwHide"
                      [title]="pwHide? translate.instant('LOGIN.PW-SHOW'):translate.instant('LOGIN.PW-HIDE')">
            </fa-icon>
          </div>
        </div>

        <div class="d-flex flex-column">
          <button type="submit" class="btn btn-primary btn-block" data-cy="submit-btn">{{'REGISTRIERUNG.SAVE-BTN' | translate}}</button>
        </div>

      </form>
    </div>
  </div>
</app-default-layout>
